import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { Ticket, ticketType, Route } from '../../types/slices/ticketType'

const initialState: ticketType =
{
    status: ApiStatus.FETCHED,
    tickets: [],
    totalRows: 0,
    routes: [],
    routesInvoice: [],
    ticketSelected: {} as Ticket,
    routeSelected: {} as Route,
    errorMessage: undefined,
    action: '',
    n_tickets: 0,
    n_routeInvoice: 0
}

const ticketSlice = createSlice({
    name: 'ticketSlice',
    initialState,
    reducers: {
        onFetchTicket (state, { payload }: { payload: Ticket[]}) {
            state.status = ApiStatus.FETCHED
            state.tickets = payload
            state.errorMessage = undefined
        },
        onFetchRoute (state, { payload }: { payload: Route[]}) {
            state.status = ApiStatus.FETCHED
            state.routes = payload
            state.errorMessage = undefined
        },
        onFetchRouteInvoice (state, { payload }: { payload: Ticket[]}) {
            state.status = ApiStatus.FETCHED
            state.routesInvoice = payload
            state.errorMessage = undefined
        },
        onSetSelectedTicket (state, { payload }: { payload: Ticket }) {
            state.ticketSelected = payload
        },
        onSetSelectedRoute (state, { payload }: { payload: Route }) {
            state.routeSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
        onSetNumberTickets (state, { payload }: { payload: number }) {
            state.n_tickets = payload
        },
        onSetNumberRouteInvoice (state, { payload }: { payload: number }) {
            state.n_routeInvoice = payload
        },
        onFetchTotalRows(state, { payload }: { payload: number }) {
            state.totalRows = payload
        }
    }
})

export const selectTicketState = (state: RootState) => state.ticketSlice
export default ticketSlice.reducer
export const {
    onFetchTicket,
    onFetchRoute,
    onFetchRouteInvoice,
    onSetSelectedTicket,
    onSetSelectedRoute,
    changeStatus,
    setAction,
    onSetNumberTickets,
    onSetNumberRouteInvoice,
    onFetchTotalRows
} = ticketSlice.actions
